import { useIntl, IntlShape } from 'react-intl';

export function useTranslation(): { $t: IntlShape['formatMessage'] } {
  const { formatMessage } = useIntl();

  return { $t: formatMessage };
}
